var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.622,
    height: 12.588,
    viewBox: "0 0 13.622 12.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M4.5,10.837H16.915m0,0L11.328,5.25m5.587,5.587-5.587,5.587",
    transform: "translate(-4 -4.543)",
    fill: "none",
    stroke: "#0a1e5b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDark);
export default __webpack_public_path__ + "static/media/arrow-right-dark.d5b39f06d37a5ea79ec0fe9b8f943a89.svg";
export { ForwardRef as ReactComponent };